import React, { useState } from 'react'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../CommonComponents/PiePage.component'
import InputField from '../../CommonComponents/InputMUI'
import SelectField from '../../CommonComponents/SelectMUI'
import MultiSelect from '../../CommonComponents/MultiSelectMUI'
import MultiInput from '../../CommonComponents/MutiInputTextField'
import { SaveUpdateDealerEvScorecard } from '../AddEditDealer/DealerActioncreator'


const minnpaData = [
    {
        code: '0',
        name: '0'
    },
    {
        code: '6',
        name: '6'
    },
    {
        code: '11',
        name: '11'
    },
    {
        code: '16',
        name: '16'
    },
]
export default function BasicDetails({ handlePage, handleTabs, communityId, Detaildata }) {
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [npaList, setNPAList] = useState([])
    const [ObjectData, setObjectData] = useState({
        // minNPA: '',
        // maxNPA: '',
        // weightage: '',
        "subParam": Detaildata?.name,
        "weightage": null,
        "npa": null
    })


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)



        // if(type === "minNPA"){
        //     if(e == ""){
        //         changeObjectData[type] = ""
        //         changeObjectData["maxNPA"] = ""
        //         changeObjectData["weightage"] = ""
        //         removeError(0)
        //     }
        //     else if(e >= 0 && e <= 16){

        //         if(e == 0){
        //               changeObjectData["maxNPA"] = "6"
        //             changeObjectData["weightage"] = "20";
        //         }else if(e ==6){
        //               changeObjectData["maxNPA"] = "11"
        //             changeObjectData["weightage"] = "15";
        //         }else if(e == 11){
        //               changeObjectData["maxNPA"] = "16"
        //             changeObjectData["weightage"] = "10";
        //         }else if(e == 16 ){
        //               changeObjectData["maxNPA"] = "2147483647"
        //             changeObjectData["weightage"] = "5";
        //         }
        //         changeObjectData[type] = e
        //     }
        // }

        // else{
        changeObjectData[type] = e
        // }

        setObjectData(changeObjectData)


    }


    const saveHandler = (e) => {
        if (e === 'save') {
            setloaderState(true)
            const obj = { ...ObjectData, communityId: communityId,creditParam: "Dealer Name",creditParamId:"" }
            SaveUpdateDealerEvScorecard(obj, (callback) => {
                setloaderState(false)
                console.log(callback)


            })
        } else if (e === 'close') {
            handlePage("", "list")
        } else if (e === "continue") {
            handleTabs("documents")

        }
    }

    const removeError = (time) => {
        setTimeout(() => {
            setmaxNPAError({
                show: false,
                errorValue: '',
                errorFor: ''
            })
        }, time)
    }

    return (
        <>
            {loaderState ?
                <Loader />
                : null}
            <div className='container hoverNone card'>

                <PiePage
                    totalPage={6}
                    currentPage={5}
                    heading={'Add BRE Configuration'}
                />


                <div className='row'>
                    
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="subParam"
                            variant="outlined"
                            value={ObjectData.subParam}
                            name="subParam"
                            id="subParam"
                            type="text"
                            onChange={e => inputChange(e, 'subParam')}
                            size="small"
                           
                        />
                       


                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="NPA"
                            variant="outlined"
                            value={ObjectData.npa}
                            name="npa"
                            id="npa"
                            type="number"
                            onChange={e => inputChange(e, 'npa')}
                            size="small"
                          
                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Weightage"
                            variant="outlined"
                            value={ObjectData.weightage}
                            name="weightage"
                            id="weightage"
                            type="number"
                            onChange={e => inputChange(e, 'weightage')}
                            size="small"
                           
                        />
                        {/* {
                            errors?.email &&
                            <div id="nameHelp" className="form-text text-danger">{errors?.email}</div>
                        } */}

                    </div>
                </div>



                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save BRE</button>
                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('continue')}>Continue</button>
                    </div>
                </div>
            </div>

            {/* <div className='container hoverNone card' style={{ marginTop: '50px' }}>
                <h4 style={{ margin: '10px 0 20px 0' }}><b>Added BRE Configurations</b></h4>
                <div className='table-responsive full-height' >

                    <>
                        <div style={{ overflowX: 'auto' }}>
                            <table className='table credhub-table'>
                                <thead>
                                    <tr>

                                        <th scope='col'>S.No.</th>
                                        <th scope="col">Min NPA</th>
                                        <th scope="col">Max NPA</th>
                                        <th scope="col">Weightage</th>
                                        <th scope="col">Edit</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {npaList && npaList?.length > 0 ? npaList?.map((row, i) => {
                                        return (
                                            <tr key={i}>


                                                <td>{i + 1}</td>
                                                <td>{row?.minNPA}</td>
                                                <td>{row.maxNPA}</td>
                                                <td>{row.weightage}</td>
                                                <td>
                                                    <button className='btn action-btn'>
                                                        <i className='fa fa-trash-o' />
                                                    </button>
                                                </td>

                                            </tr>
                                        )
                                    }) : null}
                                </tbody>
                            </table>
                        </div>

                    </>

                </div>
            </div> */}

        </>
    )
}
